import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appCommercial]'
})
export class CommercialDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
